import { useDispatch } from 'react-redux';
import { useOnUnmount } from '../../../../hooks';
import * as IssuesV2Store from '../../../../redux/issuesV2';

/**
 * Simple hook which will dispatch the clearUpdateErrors when the component unmounts.
 * Used in all of the actions modals, so that they don't display stale error messages
 * when you reopen the modal (or open another modal).
 */
const useClearErrorsOnUnmount = () => {
  const dispatch = useDispatch();

  useOnUnmount(() => {
    dispatch(IssuesV2Store.actions.clearUpdateErrors());
  });
};

export default useClearErrorsOnUnmount;
